import { CsvValidationError } from '@/components/common/Validations/CsvValidations';
import { csvDataUri } from '@/utils/csv';

// data: URI download of validation errors, shared by the manual upload modal and the
// SFTP Files card so both export identical, correctly quoted CSVs
export const errorsCsvDataUri = (errors: CsvValidationError[]): string => csvDataUri([
  ['details', 'error', 'row'],
  ...errors.map(error => [error.details, error.error, error.row]),
]);
